import { render, staticRenderFns } from "./FormularioDePostulacion.vue?vue&type=template&id=1baf2a81&scoped=true"
import script from "./FormularioDePostulacion.vue?vue&type=script&lang=js"
export * from "./FormularioDePostulacion.vue?vue&type=script&lang=js"
import style0 from "./FormularioDePostulacion.vue?vue&type=style&index=0&id=1baf2a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf2a81",
  null
  
)

export default component.exports